<footer>
  <div class="login-footer">
    <div class="row p-0 relative-margin" *ngIf="login">
      <div class="col-12 col-md-6 col-lg-7 bg-alice">
        <div class="row" style="margin-top: 90px;">
          <div class="col-12 col-sm-8 col-lg-12 col-xl-9">
            <div class="mb-0 footer-text">
              © {{date}} {{ "LOGIN.QUICKHEALTECHNOLOGIES" | translate }}
              {{ "SIGNUP.ALLRIGHTSRESERVED" | translate }}.
              <a href="https://www.quickheal.co.in/privacy-policy" rel="noopener" target="_blank">{{
                "SIGNUP.PrivacyPolicy" | translate }}</a>
              |
              <a href="https://www.quickheal.co.in/eula" target="_blank" rel="noopener">{{
                "SIGNUP.EULA" | translate }}</a>
            </div>
          </div>
          <div class="col-12 my-2 my-sm-0 col-sm-4 col-lg-12 col-xl-3 text-end">
            <div class="socialIconsHW">
              <a href="https://twitter.com/quickheal" target="_blank" rel="noopener">
                <div class="me-2 twitter"></div>
              </a>
              <a href="https://www.facebook.com/quickhealav" target="_blank" rel="noopener">
                <div class="me-2 facebook"></div>
              </a>

              <a href="https://blogs.quickheal.com" target="_blank" rel="noopener">
                <div class="me-2 blogs"></div>
              </a>
              <a href="https://www.youtube.com/user/quickheal" target="_blank" rel="noopener">
                <div class="me-2 youtube"></div>
              </a>
              <a href="https://techsupport.quickheal.com/index.php?/selfhelp/categories" target="_blank" rel="noopener">
                <div class="me-2 quickheal"></div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-0 col-md-6 col-lg-5"></div>
    </div>
  </div>

  <div class="row p-0" *ngIf="!login">
    <div class="col-8  footer-version">
      <small class="mb-0 ms-3 footer-version">
        © {{date}} {{ "LOGIN.QUICKHEALTECHNOLOGIES" | translate }}
        {{ "SIGNUP.ALLRIGHTSRESERVED" | translate }}. |
        <a href="https://www.quickheal.co.in/privacy-policy" target="_blank" rel="noopener">{{
          "SIGNUP.PrivacyPolicy" | translate
          }}</a>
        |
        <a href="https://www.quickheal.co.in/eula" target="_blank" rel="noopener">{{
          "SIGNUP.EULA" | translate }}</a>
      </small>
    </div>
    <div class="col-1"></div>
    <div class="col-2 d-flex justify-content-end">
      <small class="mb-0">{{ "SIGNUP.CCMSERVERVER" | translate }}{{ccmServerVersion}} </small>
    </div>
  </div>
</footer>